import { TableHeader } from 'components/UI/V3/Table/Header/TableHeader';
import { TableHeaderCell } from 'components/UI/V3/Table/HeaderCell/TableHeaderCell';
import Checkbox from 'components/UI/V3/Forms/Checkbox';
import { Sort } from '@spike/model';
import { FunctionComponent } from 'react';
import HeaderTableColumn from './HeaderTableColumn';
import styles from './DaycareHeaderTable.module.scss';
import { appointmentSortColumns } from './groomingSort';
import {
    bookedAtSorter,
    clientSorter,
    petSorter,
    roomSorter,
    serviceSorter,
    Sorter,
    statusSorter,
    totalSorter
} from './sorting';

interface DaycareHeaderTableProps {
    sort?: Sort | null;
    onSort?: (sort: Sort) => void;
    sorter?: Sorter | null;
    onClientSort?: (sorter: Sorter) => void;
    allSelected?: boolean;
    onToggleSelectAll?: (checked: boolean) => void;
}

export const DaycareHeaderTable: FunctionComponent<DaycareHeaderTableProps> = props => {
    const serverSort = Boolean(props.onSort);

    return (
        <TableHeader>
            {props.onToggleSelectAll && (
                <TableHeaderCell className={styles.checkboxCell}>
                    <Checkbox
                        checked={props.allSelected}
                        onChange={props.onToggleSelectAll}
                    />
                </TableHeaderCell>
            )}
            <HeaderTableColumn
                sortColumn={serverSort ? appointmentSortColumns.client : undefined}
                selectedSort={props.sort}
                onServerSort={props.onSort}
                columnSorter={serverSort ? undefined : clientSorter}
                selectedSorter={props.sorter}
                onSort={props.onClientSort}
            >
                Client Name
            </HeaderTableColumn>
            <HeaderTableColumn
                sortColumn={serverSort ? appointmentSortColumns.pet : undefined}
                selectedSort={props.sort}
                onServerSort={props.onSort}
                columnSorter={serverSort ? undefined : petSorter}
                selectedSorter={props.sorter}
                onSort={props.onClientSort}
            >
                Pet Name
            </HeaderTableColumn>
            <HeaderTableColumn
                sortColumn={serverSort ? appointmentSortColumns.service : undefined}
                selectedSort={props.sort}
                onServerSort={props.onSort}
                columnSorter={serverSort ? undefined : serviceSorter}
                selectedSorter={props.sorter}
                onSort={props.onClientSort}
            >
                Service
            </HeaderTableColumn>
            <HeaderTableColumn
                sortColumn={serverSort ? appointmentSortColumns.room : undefined}
                selectedSort={props.sort}
                onServerSort={props.onSort}
                columnSorter={serverSort ? undefined : roomSorter}
                selectedSorter={props.sorter}
                onSort={props.onClientSort}
            >
                Room
            </HeaderTableColumn>
            <HeaderTableColumn
                sortColumn={serverSort ? appointmentSortColumns.bookedAt : undefined}
                selectedSort={props.sort}
                onServerSort={props.onSort}
                columnSorter={serverSort ? undefined : bookedAtSorter}
                selectedSorter={props.sorter}
                onSort={props.onClientSort}
            >
                Date & Time
            </HeaderTableColumn>
            <HeaderTableColumn
                sortColumn={serverSort ? appointmentSortColumns.total : undefined}
                selectedSort={props.sort}
                onServerSort={props.onSort}
                columnSorter={serverSort ? undefined : totalSorter}
                selectedSorter={props.sorter}
                onSort={props.onClientSort}
            >
                Total
            </HeaderTableColumn>
            <HeaderTableColumn
                sortColumn={serverSort ? appointmentSortColumns.status : undefined}
                selectedSort={props.sort}
                onServerSort={props.onSort}
                columnSorter={serverSort ? undefined : statusSorter}
                selectedSorter={props.sorter}
                onSort={props.onClientSort}
            >
                Status
            </HeaderTableColumn>
        </TableHeader>
    );
};

export default DaycareHeaderTable;
